import script from "./Color.vue?vue&type=script&setup=true&lang=js"
export * from "./Color.vue?vue&type=script&setup=true&lang=js"

import "./Color.vue?vue&type=style&index=0&id=01004a36&lang=scss"

const __exports__ = script;

export default __exports__